import { render, staticRenderFns } from "./BbppProductServicesCH.vue?vue&type=template&id=280a0672"
import script from "./BbppProductServicesCH.vue?vue&type=script&lang=js"
export * from "./BbppProductServicesCH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports